
export const FETCH_USERACCESS = 'FETCH_USERACCESS';
export const GET_USERACCESS_BY_EMAIL = 'GET_USERACCESS_BY_EMAIL';
export const SET_USERACCESSES = 'SET_USERACCESSES';
export const GET_USERACCESS = 'GET_USERACCESS';
export const SET_USERACCESS = 'SET_USERACCESS';
export const ADD_USERACCESS = 'ADD_USERACCESS';
export const ADD_SUCCESS = 'ADD_SUCCESS';
export const PUT_SUCCESS = 'PUT_SUCCESS';
export const UPDATE_USERACCESS = 'UPDATE_USERACCESS';
export const DELETE_USERACCESS = 'DELETE_USERACCESS';
export const DELETE_USERACCESS_SUCCESS = 'DELETE_USERACCESS_SUCCESS';
export const CLEAR_DELETE_USERACCESS = 'CLEAR_DELETE_USERACCESS';
export const FETCH_SEARCH_USERACCESS = 'FETCH_SEARCH_USERACCESS';
export const SET_SEARCH_USERACCESS = 'SET_SEARCH_USERACCESS';
export const FETCH_COUNTER_USERACCESS = 'FETCH_COUNTER_USERACCESS';
export const SET_COUNTER_USERACCESS = 'SET_COUNTER_USERACCESS';
